/* app - mutation */
export const SET_APP_INFO = 'SET_APP_INFO';
export const APPEND_APP_LIST = 'APPEND_APP_LIST';
export const CLEAR_APP_LIST = 'CLEAR_APP_LIST';
export const SORT_APP_LIST = 'SORT_APP_LIST';
/* app - action */
export const FETCH_COMMERCE_APP_LIST = 'FETCH_COMMERCE_APP_LIST';


// WEBPACK FOOTER //
// ./src/store/types/app.js